export const log_event = (action, event_name) => {
  try {
    window.gtag("event", action, {
      event_category: event_name
    });
  } catch (e) {
    //
  }
};
